<template lang="pug">
  .analise
    app-modal-visualizar-completo(
        v-if="showModalVisualizarProcesso && idProcesso !== null",
        @closeModal="showModalVisualizarProcesso = false",
        :idProcesso="idProcesso",
        :protocolo="protocolo",
        :numeroProcesso="numeroProcesso",
        :tipo="tipoProcesso"
    )
    el-card.card-container(shadow="hover")
      filtro(
        @pesquisar="pesquisarFiltro",
        @limpar="clearFiltro",
        @changePesquisa="changePesquisa",
        :configuracaoFiltro="configuracaoFiltro"
        :filtro="filtro",
        :isConsultaProcessosAntigos="true"
      )
    app-listagem(
      :hasActionButton="true"
      :sizeActionButton="false"
      :showButtonCadastrar="false"
      :hasHeader="true"
      :hasRefreshButton="false"
      :headerLabel="headerLabel"
      :dataForTable="items"
      :totalElements="totalElements"
      :pagina="filtro.pagina + 1"
      @click="cadastrar"
      @changePage="changePage"
      @sort="sort"
    )
      template(slot="columns")
        el-table-column(
          label='Número do processo',
          prop='numeroProcesso'
          min-width='120',
          sortable
        )
        el-table-column(
          label='Nome/Razão social do interessado',
          prop='nomeRazaoSocialInteressado'
          min-width='120',
          sortable
        )
        el-table-column(
          label='CPF/CNPJ do interessado',
          prop='cpfCnpjInteressado'
          min-width='120',
          sortable
        )
        el-table-column(
          :formatter="(row) => setData(row.dataCadastro)"
          label='Data de Cadastro',
          min-width="120"
          prop= "dataAlterado"
          sortable
        )
        el-table-column(
          label='Município',
          min-width='120',
          prop='municipio',
          sortable
        )
        el-table-column(
          label='Área(ha)',
          prop='areaTotal'
          :formatter="(row) => formatarArea(row.areaImovel)"
          min-width='120',
          sortable
        )

        el-table-column(
          label="Ações",
          width="110",
          align="center"
        )
          template(slot-scope='scope')
            el-dropdown(trigger="click", size="small")
              el-button(type='primary', size="mini")
                | Ações
                i.el-icon-arrow-down.el-icon--right
              el-dropdown-menu(slot='dropdown')
                div
                  el-dropdown-item
                    .flex(@click="visualizar(scope.row)")
                      i.fa.fa-eye.icon-teste
                      | &nbsp Visualizar
    div.container-exportar
      el-button(
        @click="exportar"
      )
        span
          i.fal.fa-file-csv
          | &nbsp Exportar CSV
</template>
<script>

import Filtro from '../components/Filter.vue'
import AppListagem from '@/components/shared/AppListagem'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import FILTRO_EMPTY from '../models/filtroProcessoAntigo'
import { mapActions } from 'vuex'
import moment from 'moment'
import AppModalVisualizarCompleto from '../../analise/components/modal/AppModalVisualizarCompleto.vue'

export default {
  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      idProcesso: null,
      showModalVisualizarProcesso: false,
      protocolo: '',
      numeroProcesso: '',
      tipoProcesso: '',
      items: [],
      processo: undefined,
      showModal: false,
      totalElements: 0,
      configuracaoFiltro: {},
      headerLabel: 'Resultado da Pesquisa',
      modal: false,
      filtro: {...FILTRO_EMPTY()}
    }
  },

  computed: {
  },

  async created () {
    this.pesquisar(this.filtro)
  },

  methods: {
    ...mapActions({
      getProcessoBancoDadosCsv: 'processo/getProcessoBancoDadosCsv',
      getProcessosAntigo: 'processo/getProcessosAntigo'
    }),
    visualizar (item) {
      this.setDadosProcesso(item)
      this.showModalVisualizarProcesso = true
    },
    setDadosProcesso (item) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.processo = item
      this.protocolo = item.numeroProtocolo
      this.tipoProcesso = item.tipoCodigo
      this.processo = item
    },
    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.pesquisar(this.filtro)
    },
    async pesquisarFiltro (filtro) {
      await this.pesquisar(this.filtro)
    },
    async clearFiltro () {
      this.filtro = {...FILTRO_EMPTY(), ordem: 'id'}
      await this.pesquisar(this.filtro)
    },
    async pesquisar (filtro) {
      const resp = await this.getProcessosAntigo(filtro)
      this.items = resp.content
      this.totalElements = resp.totalElements
    },
    changePesquisa () {
      this.filtro = {
        ...FILTRO_EMPTY(),
        ordem: 'id',
        simplificado: !this.filtro.simplificado
      }
    },
    setData (data) {
      if (data) {
        return moment(data).format('DD/MM/YYYY')
      }
      return '-'
    },
    getMunicipiosNome (municipios, sepadarador = ', ') {
      return municipios.map(item => item.nome).join(sepadarador)
    },
    formatarArea (area) {
      return area ? area.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : '-'
    },
    closeModal () {
      this.modal = false
    },
    sort ({ column, prop, order }) {
      if (order === 'ascending') {
        this.filtro.ordemDirecao = 'ASC'
      } else {
        this.filtro.ordemDirecao = 'DESC'
      }
      this.filtro.ordem = prop
      this.pesquisar(this.filtro)
    },
    exportar () {
      this.getProcessoBancoDadosCsv(this.filtro)
    }
  }
}

</script>
<style>
.label {
  font-weight: bold;
}

.analise {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.card-collapse {
  border-radius: 10px;
  margin: 10px 0;
}

.btn-actions {
  display: flex;
  justify-content: space-between;
}
.container-btn {
  display: flex;
  justify-content: end;
  margin-right: 20px;
}
.flex {
  display: flex;
  align-items: center;
}

.flex button {
  margin-bottom: 1em;
}

.flex .el-button span {
  display: flex;
}

.right {
  float: right;
}

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.titulo-cadastar-foto {
  margin: 20px;
  color: #000;
}
.icon-teste {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 27px !important;
  margin: 0px !important;
}
.container-exportar {
  display: flex;
  justify-content: end;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/bancoDados/consultaProcessosAntigos/ConsultaProcessosAntigos.vue